import React from 'react';
import BannerHeader from '../../Component/Header/BannerHeader';
import Footer from '../../Component/Footer/Footer';
import './Disclaimer.css';

function Disclaimer() {
  return (
    <>
      <BannerHeader />
      <main className="disclaimer-page">
        <div className="disclaimer-container">
          <div className="disclaimer-content">
            <h1 className="disclaimer-title">Simule Inc. - Legal Disclaimers and Terms</h1>
            
            <section className="disclaimer-section">
              <h2>Website Disclaimer</h2>

          <p>
            Simule is a decentralized platform offering digital land collectibles in the form of NFTs. Each NFT represents
            a defined area of virtual land and is priced at 0.000004 ETH per square foot. The pricing model is tied to the
            digital footprint of the parcel on the map and grants access to a unique non-fungible token associated with
            Simule Inc.'s proprietary geospatial IP.
          </p>
          <p>
            These NFTs are intended solely as digital collectibles or utilities within the Simule ecosystem and do not
            constitute ownership or legal rights over any physical land or real-world location. They carry no implied value
            beyond the experience or utility offered within the platform.
          </p>
          <p>
            All fees collected via the Ethereum blockchain are used to maintain and expand the Simule platform.
            Transactions are irreversible, and Simule Inc. does not control or custody any user funds.
          </p>
          <p>
            Use of this platform constitutes agreement with our Terms of Use and acknowledgment that you are
            purchasing digital IP collectibles, not investment instruments.
          </p>
        </section>

        <section className="disclaimer-section">
          <h2>Terms of Use</h2>

          
          <div className="term-item">
            <h3>1. Non-Custodial System</h3>
            <p>Simule is a non-custodial platform. You remain in full control of your cryptocurrency and NFTs at all times. No
            user funds are ever held by Simule Inc.</p>
          </div>

          <div className="term-item">
            <h3>2. Digital Collectibles Only</h3>
            <p>The NFTs offered are digital items representing virtual collectibles. They are not securities, investments, or
            claims to physical assets.</p>
          </div>

          <div className="term-item">
            <h3>3. Smart Contract Governance</h3>
            <p>All transactions occur via decentralized smart contracts, which are immutable and publicly accessible. Simule
            Inc. does not have the ability to alter, reverse, or interfere with any transaction.</p>
          </div>

          <div className="term-item">
            <h3>4. Fees</h3>
            <p>A small ETH fee is collected via smart contracts to support platform sustainability. This fee is transparently
            defined in the smart contract and not subject to change by Simule Inc.</p>
          </div>

          <div className="term-item">
            <h3>5. Assumption of Risk</h3>
            <p>By interacting with the platform, you assume full responsibility for any outcomes, including loss of access to
            NFTs, changes in digital asset value, or technical failures on-chain.</p>
          </div>

          <div className="term-item">
            <h3>6. No Warranty</h3>
            <p>Simule Inc. provides the platform "as-is" with no guarantees, express or implied, of uptime, compatibility, or
            profitability.</p>
          </div>

          <div className="term-item">
            <h3>7. Legal Jurisdiction</h3>
            <p>Simule Inc. is a Delaware C-Corp. Use of the platform is subject to applicable U.S. laws. You are responsible
            for understanding and complying with the laws of your own jurisdiction.</p>
          </div>

          <div className="term-item">
            <h3>8. NFT Pricing and IP Licensing</h3>
            <p>Digital land NFTs on Simule are priced at a fixed rate of 0.000004 ETH per square foot. This pricing reflects a
            license to a digital representation of Simule Inc.'s proprietary geospatial data and does not constitute a
            transfer of physical property or legal land rights.</p>
            <p>By purchasing a digital parcel, you obtain an NFT that references a unique coordinate-based location on
            Simule's virtual map. The NFT grants you a limited, non-exclusive, non-transferable license to use the
            associated IP as a digital collectible within permitted uses outlined by Simule Inc.</p>
            <p>This is a software-based digital good. All purchases are final.</p>
          </div>
        </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default Disclaimer;
